import React, { useEffect } from 'react';

import i18n from 'i18n';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { initialLanguage, features } from 'configs';
import Routes from 'navigation/Routes';
import { EHRBypassRoutes } from 'navigation/EHRBypassRoutes';
import { UserContextProvider } from 'store/UserContext';
import 'theme/global.css';
import { AccessibilityContextProvider } from 'contexts/AccessibilityContext';

const getFaviconEl = () => document.getElementById('favicon');

const App = () => {
  const favicon = getFaviconEl();

  favicon.href = 'ebserh/favicon.ico';

  useEffect(() => {
    if (initialLanguage) i18n.changeLanguage(initialLanguage);
    else i18n.changeLanguage('pt-BR');
  }, []);

  return (
    <AccessibilityContextProvider>
      <UserContextProvider>
        <div translate="no">
          {features.bypassLoginPageWithVisualizer ? (
            <EHRBypassRoutes />
          ) : (
            <Routes />
          )}
          <ToastContainer hideProgressBar />
        </div>
      </UserContextProvider>
    </AccessibilityContextProvider>
  );
};

export default App;
